/* __next_internal_client_entry_do_not_use__ Upload auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1761))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.157Z
 */ export var Upload = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M0.857422 18V19.7143C0.857422 20.6236 1.21865 21.4957 1.86163 22.1387C2.50461 22.7816 3.37668 23.1429 4.28599 23.1429H19.7146C20.6239 23.1429 21.4959 22.7816 22.1389 22.1387C22.7819 21.4957 23.1431 20.6236 23.1431 19.7143V18",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M6.85693 6.85718L11.9998 0.857178L17.1426 6.85718",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M12 0.857178V16.2857",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "Upload", function(strictLocalize) {
    return {
        viewBox: "0 0 24 24",
        titleAccess: strictLocalize({
            id: "4YSa2T",
            defaultMessage: [
                {
                    type: 0,
                    value: "Upload"
                }
            ]
        }),
        fill: "none",
        color: Core.icon.default
    };
});
